<section class="agent-confirm">
  <img [src]="'assets/images/' + image" alt="Sent To Agent" />

  <h2 data-cy="confirmationScreenHeader" class="heading-text">
    {{ header }}
  </h2>
  <p class="agent-msg">{{ message }}</p>
  @for (agent of agents; track agent) {
    <div class="agent-item-column flex justify-center">
      <agent-item
        [defaultContactNumber]="defaultContactNumber"
        [agent]="agent"
        [newTemplate]="true"
        [onlyHeader]="true"
      ></agent-item>
    </div>
  }
  <section class="agent-action">
    <call-to-action
      [displayBackButton]="false"
      [primaryButtonName]="primaryButtonName"
      [secondaryButtonName]="secondaryButtonName"
      (primaryEvent)="primaryButtonClicked.emit()"
      (secondaryEvent)="secondaryButtonClicked.emit()"
      [equalWidthButtons]="true"
      [preserveTextFormat]="true"
    ></call-to-action>
  </section>
</section>
